// Common competitive moves with their properties
export const MOVES = {
  "Dragon Darts": {
    name: "Dragon Darts",
    type: "Dragon",
    category: "Physical",
    basePower: 50,
    description: "Fires two darts dealing 50 BP each (100 BP total). In doubles, if two opponents are present, each dart automatically targets a different one. 100% accuracy."
  },
  "Shadow Ball": {
    name: "Shadow Ball",
    type: "Ghost",
    category: "Special",
    basePower: 80,
    description: "Hurls a dark orb for 80 BP. Has a 20% chance to lower the target's Special Defense by 1 stage. 100% accuracy."
  },
  "Ice Beam": {
    name: "Ice Beam",
    type: "Ice",
    category: "Special",
    basePower: 90,
    description: "Fires an icy beam for 90 BP. Has a 10% chance to freeze the target. 100% accuracy."
  },
  "Thunderbolt": {
    name: "Thunderbolt",
    type: "Electric",
    category: "Special",
    basePower: 90,
    description: "Fires an electric bolt for 90 BP. Has a 10% chance to paralyze the target. 100% accuracy."
  },
  "Flamethrower": {
    name: "Flamethrower",
    type: "Fire",
    category: "Special",
    basePower: 90,
    description: "Fires a stream of flames for 90 BP. Has a 10% chance to burn the target. 100% accuracy."
  },
  "Close Combat": {
    name: "Close Combat",
    type: "Fighting",
    category: "Physical",
    basePower: 120,
    description: "Powerful 120 BP attack. Lowers the user's Defense and Special Defense by 1 stage each after use. 100% accuracy."
  },
  "Earthquake": {
    name: "Earthquake",
    type: "Ground",
    category: "Physical",
    basePower: 100,
    description: "100 BP Ground move. Hits all adjacent Pokemon in doubles battles, including allies — use with caution. Deals double damage to Pokemon in the semi-invulnerable Dig turn. 100% accuracy."
  },
  "Dragon Claw": {
    name: "Dragon Claw",
    type: "Dragon",
    category: "Physical",
    basePower: 80,
    description: "A reliable 80 BP Dragon-type slash with no secondary effect. 100% accuracy makes it a safe, consistent damage option."
  },
  "Psychic": {
    name: "Psychic",
    type: "Psychic",
    category: "Special",
    basePower: 90,
    description: "Fires a psychic blast for 90 BP. Has a 10% chance to lower the target's Special Defense by 1 stage. 100% accuracy."
  },
  "Hydro Pump": {
    name: "Hydro Pump",
    type: "Water",
    category: "Special",
    basePower: 110,
    description: "A high-power Water blast dealing 110 BP, but only 80% accuracy. Misses roughly 1 in 5 uses — high risk, high reward."
  },
  "Fire Blast": {
    name: "Fire Blast",
    type: "Fire",
    category: "Special",
    basePower: 110,
    description: "A powerful Fire attack dealing 110 BP with 85% accuracy. Has a 10% chance to burn the target."
  },
  "Dark Pulse": {
    name: "Dark Pulse",
    type: "Dark",
    category: "Special",
    basePower: 80,
    description: "Fires a dark beam for 80 BP. Has a 20% chance to make the target flinch (lose its turn). 100% accuracy."
  },
  "Iron Head": {
    name: "Iron Head",
    type: "Steel",
    category: "Physical",
    basePower: 80,
    description: "Slams with an iron head for 80 BP. Has a 30% chance to make the target flinch (lose its turn). 100% accuracy."
  },
  "Play Rough": {
    name: "Play Rough",
    type: "Fairy",
    category: "Physical",
    basePower: 90,
    description: "A rough-and-tumble Fairy attack dealing 90 BP. Has a 10% chance to lower the target's Attack by 1 stage. 90% accuracy."
  },
  "Leaf Blade": {
    name: "Leaf Blade",
    type: "Grass",
    category: "Physical",
    basePower: 90,
    description: "Slashes with a sharp leaf for 90 BP. Has a high critical hit ratio (12.5% instead of the standard 4.2%). 100% accuracy."
  },
  "Hyper Voice": {
    name: "Hyper Voice",
    type: "Normal",
    category: "Special",
    basePower: 90,
    description: "A loud Normal-type attack dealing 90 BP. Bypasses the Substitute protection. 100% accuracy."
  },
  "Body Slam": {
    name: "Body Slam",
    type: "Normal",
    category: "Physical",
    basePower: 85,
    description: "Slams the target with the full body for 85 BP. Has a 30% chance to paralyze the target. 100% accuracy."
  },
  "Sludge Bomb": {
    name: "Sludge Bomb",
    type: "Poison",
    category: "Special",
    basePower: 90,
    description: "Hurls sludge for 90 BP. Has a 30% chance to poison the target. 100% accuracy."
  },
  "Brave Bird": {
    name: "Brave Bird",
    type: "Flying",
    category: "Physical",
    basePower: 120,
    description: "A reckless dive dealing 120 BP. The user takes 1/3 of the damage dealt as recoil. 100% accuracy."
  },
  "Hurricane": {
    name: "Hurricane",
    type: "Flying",
    category: "Special",
    basePower: 110,
    description: "A powerful 110 BP wind attack. Has a 30% chance to confuse the target. Only 70% accuracy in clear weather, but never misses in Rain."
  },
  "Bug Buzz": {
    name: "Bug Buzz",
    type: "Bug",
    category: "Special",
    basePower: 90,
    description: "A loud buzzing sound attack dealing 90 BP. Has a 10% chance to lower the target's Special Defense by 1 stage. 100% accuracy."
  },
  "U-turn": {
    name: "U-turn",
    type: "Bug",
    category: "Physical",
    basePower: 70,
    description: "Deals 70 BP damage and forces the user to switch out afterward, even if the target faints. 100% accuracy."
  },
  "Stone Edge": {
    name: "Stone Edge",
    type: "Rock",
    category: "Physical",
    basePower: 100,
    description: "Sharp rocks deal 100 BP damage. Has a high critical hit ratio (12.5%). Only 80% accuracy — high risk, high reward."
  },
  "Rock Slide": {
    name: "Rock Slide",
    type: "Rock",
    category: "Physical",
    basePower: 75,
    description: "Falling rocks deal 75 BP damage. Has a 30% chance to make the target flinch. In doubles, hits both opponents. 90% accuracy."
  }
}; 